export const LIFE_CYCLE_OPTIONS = [
  { value: 'Prospect', label: '🌱 Prospect' },
  { value: 'Lead', label: '🎣 Lead' },
  { value: 'Customer', label: '🛒 Customer' },
  { value: 'Advocate', label: '📣 Advocate' }
]

export const LEAD_STATUS_OPTIONS = [
  { value: 'new', label: '✨ New' },
  { value: 'in_progress', label: '🚧 In progress' },
  { value: 'waiting_blocked', label: '⏳ Waiting/blocked' },
  { value: 'completed', label: '✅ Completed' },
  { value: 'do_not_contact', label: '🚫 Do not contact' }
]

export function lifeCycleLabel(value) {
  if (!value) return '—'
  const hit = LIFE_CYCLE_OPTIONS.find((o) => o.value.toLowerCase() === String(value).toLowerCase())
  return hit ? hit.label : value
}

export function leadStatusLabel(value) {
  if (!value) return '—'
  const hit = LEAD_STATUS_OPTIONS.find((o) => o.value.toLowerCase() === String(value).toLowerCase())
  return hit ? hit.label : value
}
